import React, { useEffect, useState } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Services from './components/Services/Services';
import Products from './components/Products/Products';
import Industries from './components/Industries/Industries';
import WhyUs from './components/WhyUs/WhyUs';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import { useReveal } from './hooks/useScrollAnimations';

function App() {
  const [activeSection, setActiveSection] = useState('home');
  useReveal();

  useEffect(() => {
    const sections = document.querySelectorAll('section[id]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActiveSection(entry.target.id);
      });
    }, { threshold: 0.3, rootMargin: "-100px 0px -100px 0px" });

    sections.forEach((sec) => observer.observe(sec));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">
      <Header activeSection={activeSection} />
      <main>
        <Hero />
        <About />
        <Services />
        <Products />
        <Industries />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;